<template>
  <div>

    <div class="media">
      <media-player :issue="issue" :share="false" :header="false"></media-player>
    </div>
    <issue-authors v-bind:authors="issue.authors"></issue-authors>
    <div class="description">{{ issue.description }}</div>
    <div class="doi">DOI: <span>{{ issue.ids ? issue.ids.doi : ''  }}</span><br/>
      Issue: <span>Volume {{issue.volume}} Number{{issue.issue.issue}}</span>
      pp {{issue.page_start}}-{{issue.page_end}}</div>
    <div class="title">{{ trimTextToLength(issue.title, 40) }}</div>
    <div class="keywords" v-if="showKeywords">Keywords: <span>{{issue.keywords.join(', ')}}</span></div>
    <div class="article-quick-links">
      <article-quick-links :article="issue"></article-quick-links>
    </div>
  </div>
</template>

<script>
  import ArticleQuickLinks from '@/components/shared/ArticleQuickLinksComponent'
  import IssueAuthors from '@/components/shared/IssueAuthorsComponent'
  import MediaPlayer from '@/components/shared/MediaPlayerComponent'
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'
  export default {
    name: 'condensed-video',
    props: ['issue', 'showKeywords'],
    mixins: [ UtilityMixin ],
    components: {
      ArticleQuickLinks,
      IssueAuthors,
      MediaPlayer
    }
  }
</script>

<style lang="scss" scoped>
  .media {
    position: relative;
    video {
      width: 100%;
    }
  }
  .description {
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    line-height: 1.38;
    text-align: justify;
    color: $accent-color-3;
    margin-bottom: 23.5px;
  }
  .article-quick-links {
    margin-bottom: 58.5px;
  }
  .title {
    text-decoration: underline;
    color: $accent-color-1;
    margin: 10px 0;
    font-size: 18px;
  }
  .doi {
    font-size: 12px;
    line-height: 1.42;
    text-align: left;
    color: $accent-color-3;
    span {
      color: $accent-color-1;
      text-decoration: underline;
    }
  }
  .keywords {
    font-style: italic;
    font-size: 16px;
    margin: 20px 0px;
    span {
      color: $secondary-color;
    }
  }

</style>



// WEBPACK FOOTER //
// CondensedVideoComponent.vue?a08d6a74